export default __webpack_public_path__ + "static/media/palette.57231df3.svg";